import { BASE_AUDIT_API, fetchAPI } from '@/services/api';

export interface C71VO {
    client?: string;
    yearEnd?: string;
    preparedBy?: string;
    reviewedBy?: string;
    turnPct?: number;
    turnAntRes?: number;
    turnMatLevel?: number;
    turnFinPct?: number;
    turnFinRes?: number;
    turnFinMatLevel?: number;
    grossPct?: number;
    grossAntRes?: number;
    grossMatLevel?: number;
    /** Backend field name (typo preserved for API compatibility). */
    grrossPercentage?: number;
    grossFinRes?: number;
    grossFinMatLevel?: number;
    proAntRes?: number;
    proFinRes?: number;
    adjusmentAntRes?: number;
    adjusmentFinRes?: number;
    adjAnticatedResults?: number;
    adjMatelityLevel?: number;
    adjFinalResults?: number;
    adjMatelityLevel2?: number;
    thisYear?: number;
    pri1?: number;
    pri2?: number;
    pri3?: number;
    pri4?: number;
}

const base = `${BASE_AUDIT_API}/income-statement`;

export type SampleSelectionVariant = 'QI1.3' | 'QE1.3';

export interface SampleSelectionPlanningVO {
    companyName?: string;
    yearEnd?: string;
    inYear?: string;
    inherentRiskFactorNumber?: number;
    materiality?: number;
    performanceMateriality?: number;
    monetaryValueOfPopulation?: number;
    valueOfItemsAbovePerformanceMateriality?: number;
    valueOfResidualPopulation?: number;
    sampleSize?: number;
    numberOfMateriality?: number;
    overSampleSize?: number;
    actualSampleSize?: number;
}

/** @deprecated Use SampleSelectionPlanningVO */
export type QI13VO = SampleSelectionPlanningVO;

export async function getQI13VO(
    companyId: number,
    annualId: number,
    populationCode?: string,
): Promise<SampleSelectionPlanningVO> {
    const popQuery = populationCode
        ? `&populationCode=${encodeURIComponent(populationCode)}`
        : '';
    return fetchAPI<SampleSelectionPlanningVO>(
        `${base}/get/getQI13VO?companyId=${companyId}&annualId=${annualId}${popQuery}`,
    );
}

export async function getQE13VO(companyId: number, annualId: number): Promise<SampleSelectionPlanningVO> {
    return fetchAPI<SampleSelectionPlanningVO>(`${base}/get/getQE13VO?companyId=${companyId}&annualId=${annualId}`);
}

export async function getC71VO(companyId: number, annualId: number): Promise<C71VO> {
    return fetchAPI<C71VO>(`${base}/get/getC71VO?companyId=${companyId}&annualId=${annualId}`);
}

export function overallFinalMateriality(data: C71VO): number {
    const turn = Number(data.turnFinMatLevel ?? 0);
    const gross = Number(data.grossFinMatLevel ?? 0);
    return Math.max(turn, gross);
}

export function performanceMateriality(overall: number, riskFactor: number): number {
    if (!overall || !riskFactor) return 0;
    return overall / riskFactor;
}

export function formatAmount(value?: number | null): string {
    if (value == null || Number.isNaN(value)) return '';
    return Number(value).toLocaleString('en-HK', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    });
}

export function formatPct(value?: number | null): string {
    if (value == null || Number.isNaN(value)) return '';
    const pct = Number(value) * 100;
    return pct % 1 === 0 ? String(pct) : pct.toFixed(2).replace(/\.?0+$/, '');
}
